'use strict'

const { createImmediateCmd, createQueuedCmd } = require('redux-serial-effects')

const DatasetError = require('../dataset-controller/DatasetError')
const isComponentValid = require('../helpers/isComponentValid')

const cmdTypes = require('./cmdTypes')
const recordsActionTypes = require('../records/actionTypes')

const TYPE = 'ADAPTER_API'

const assertComponentsValid = (componentAdapterContexts, currentRecord) => {
  const nonValidComponentAdapterContexts = componentAdapterContexts.filter(
    cac => !isComponentValid(cac, currentRecord)
  )
  nonValidComponentAdapterContexts.forEach(({ component }) =>
    component.updateValidityIndication()
  )

  if (nonValidComponentAdapterContexts.length) {
    throw new DatasetError(
      'DS_VALIDATION_ERROR',
      'Some of the elements validation failed'
    )
  }
}

const executor = (adapterApi, componentAdapterContexts) => ({
  type: TYPE,
  execute: cmd => {
    switch (cmd.type) {
      case cmdTypes.BIND_TO_COMPONENT:
        return adapterApi().bindToComponent()

      case cmdTypes.CURRENT_RECORD_MODIFIED:
        return adapterApi().currentRecordModified(
          cmd.updatedFields,
          cmd.filteredComponent
        )

      case cmdTypes.RECORD_SET_LOADED:
        return Promise.all(adapterApi().recordSetLoaded())

      case cmdTypes.CURRENT_VIEW_CHANGED:
        return Promise.all(adapterApi().currentViewChanged())

      case cmdTypes.CURRENT_INDEX_CHANGED:
        return adapterApi().currentIndexChanged()

      case cmdTypes.ASSERT_INPUT_VALIDITY:
        return assertComponentsValid(componentAdapterContexts, cmd.record)
    }
  }
})

const assertValidityCmd = record =>
  createQueuedCmd(
    TYPE,
    {
      type: cmdTypes.ASSERT_INPUT_VALIDITY,
      record
    },
    recordsActionTypes.ASSERT_VALIDITY_RESULT
  )

const bindToComponentCmd = () =>
  createImmediateCmd(TYPE, {
    type: cmdTypes.BIND_TO_COMPONENT
  })

const currentRecordModifiedCmd = (updatedFields, filteredComponent) =>
  createImmediateCmd(TYPE, {
    type: cmdTypes.CURRENT_RECORD_MODIFIED,
    updatedFields,
    filteredComponent
  })

const notifyRecordSetLoadedCmd = () =>
  createQueuedCmd(TYPE, {
    type: cmdTypes.RECORD_SET_LOADED
  })

const updateCurrentViewCmd = actionType =>
  createQueuedCmd(
    TYPE,
    {
      type: cmdTypes.CURRENT_VIEW_CHANGED
    },
    recordsActionTypes.CURRENT_VIEW_UPDATED
  )

const notifyIndexChangeCmd = () =>
  createImmediateCmd(TYPE, {
    type: cmdTypes.CURRENT_INDEX_CHANGED
  })

module.exports.executor = executor

module.exports.assertValidityCmd = assertValidityCmd
module.exports.bindToComponentCmd = bindToComponentCmd
module.exports.currentRecordModifiedCmd = currentRecordModifiedCmd
module.exports.notifyIndexChangeCmd = notifyIndexChangeCmd
module.exports.notifyRecordSetLoadedCmd = notifyRecordSetLoadedCmd
module.exports.updateCurrentViewCmd = updateCurrentViewCmd



// WEBPACK FOOTER //
// ./adapters/adapterApiExecutor.js